import { getConfigList } from '@src/api/aiAlerts';
import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import { CONFIG_LIST_KEY } from '@components/metrics-panel-hz/hooks/alerts/alertsQueryKey.constants';

export const useFetchConfigList = () => {
  const { data, isFetching, isLoading } = useQuery(
    [CONFIG_LIST_KEY],
    () => {
      return getConfigList().then((response) => get(response, ['data'], { aiAlertsConfig: [] }));
    },
    {
      retry: 3,
      refetchInterval: 5 * 60 * 1000, // 5m
      refetchOnWindowFocus: false,
      enabled: true,
      onError: () => {
        throw new Error('AI alert config list fetch error');
      },
    },
  );

  return { data, isFetching, isLoading };
};
